import {
  createStyles,
  Switch as MuiSwitch,
  SwitchProps as MuiSwitchProps,
  withStyles,
} from '@material-ui/core';
import { primaryGreen, grey } from 'src/data/colors';
import { theme } from '../theme';

type SwitchProps = MuiSwitchProps & {
  checked: boolean;
};

export const Switch = withStyles(() =>
  createStyles({
    root: {},
    switchBase: {
      color: grey,
      '&$checked': {
        color: primaryGreen,
        '& + $track': {
          backgroundColor: primaryGreen,
          opacity: 0.6,
          border: 'none',
        },
      },
      '&$focusVisible $thumb': {},
    },
    thumb: {},
    track: {
      borderRadius: 26 / 2,
      border: `1px solid ${theme.palette.grey[400]}`,
      backgroundColor: theme.palette.grey[50],
      opacity: 1,
      transition: theme.transitions.create(['background-color', 'border']),
    },
    checked: {},
    focusVisible: {},
  })
)((props: SwitchProps) => <MuiSwitch {...props} />) as React.FC<SwitchProps>;
